import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import TechpackService from "../../service/TechpackService";
import { Typography } from "@mui/material";
import { Box, CopyButton } from "../../common/components";
import { Input } from "../../common/components/Input";
import { TechpackItemCustomColor } from "../../types";
import { palette } from "../../styles/theme";
import ColorBox from "../../common/components/Select/ColorSelect/ColorBox/ColorBox";
import _ from "lodash";

interface Props {
  customColors: TechpackItemCustomColor[];
  hideCustomColorLabel?: boolean;
  //for artwork custom colors
  hideUsedOnTechpackPositions?: boolean;
}

const TechpackCustomColor = (props: Props) => {
  const { customColors, hideCustomColorLabel, hideUsedOnTechpackPositions } =
    props;
  const { t } = useTranslation();

  const formatedCustomColors = useMemo(() => {
    return customColors.map((c) => {
      return {
        id: c.id,
        fabricName: c.fabric.fabricName,
        fabricDescription: c.fabric.fabricDescription,
        hex: c.hexColor,
        usedOnTechpackPositions: c.usedOn.map((u) => u.techpackPosition),
        techpackColorReference: c.customColorName,
      };
    });
  }, [customColors]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onCustomColorUpdate = useCallback(
    _.debounce(async (id: string, techpackColorReference: string) => {
      const data = {
        techpackItemCustomColorId: id,
        customColorReference: techpackColorReference || null,
      };
      await TechpackService.setCustomColorReference(data);
    }, 1000),
    []
  );

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={!hideCustomColorLabel ? "12px" : "8px"}
    >
      <Typography variant="textRegularBold">
        {t(`techpack.custom_color`)}
      </Typography>

      <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
        {formatedCustomColors.map((c) => (
          <Box key={c.id} display={"flex"} flexDirection={"column"} gap={"4px"}>
            {!hideUsedOnTechpackPositions && (
              <Typography variant="textSm">
                {c.usedOnTechpackPositions.join(", ")}
              </Typography>
            )}
            <Box display={"flex"} gap={"8px"} alignItems={"center"}>
              <Typography
                variant="textSm"
                color={palette.grey.primary}
                display={"flex"}
                alignItems={"center"}
              >
                {!hideCustomColorLabel && t("techpack.custom_color")}
              </Typography>
              <Box display={"flex"} alignItems={"center"} gap={"2px"}>
                <ColorBox
                  colorOrCombo={c.hex}
                  size={14}
                  sx={{ cursor: "default" }}
                />
                <Box display={"flex"} alignItems={"center"} gap={"4px"}>
                  <Typography variant="textSm" color={palette.grey.primary}>
                    {c.hex}
                  </Typography>
                  <CopyButton value={c.hex.split("#")[1]} />
                </Box>
              </Box>
            </Box>
            <Input
              size="small"
              defaultValue={c.techpackColorReference}
              placeholder={t("techpack.reference_for_techpack")}
              onChange={(e) => onCustomColorUpdate(c.id, e.target.value)}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TechpackCustomColor;
